export interface DeviceInfo {
  device_type: "mobile" | "desktop" | "tablet";
  client_type: "web_browser";
  device_name: string;
  device_fingerprint: string;
}

function getDeviceType(): "mobile" | "desktop" | "tablet" {
  const ua = navigator.userAgent;
  // Tablet patterns (check before mobile — many tablets also match mobile)
  if (/iPad|Android(?!.*Mobile)|Tablet/i.test(ua)) return "tablet";
  // Mobile patterns
  if (/iPhone|iPod|Android.*Mobile|webOS|BlackBerry|IEMobile|Opera Mini/i.test(ua)) return "mobile";
  return "desktop";
}

function getDeviceName(): string {
  const ua = navigator.userAgent;

  // Browser detection
  let browser = "Browser";
  if (/Edg\//i.test(ua)) browser = "Edge";
  else if (/Chrome\//i.test(ua) && !/Chromium/i.test(ua)) browser = "Chrome";
  else if (/Firefox\//i.test(ua)) browser = "Firefox";
  else if (/Safari\//i.test(ua) && !/Chrome/i.test(ua)) browser = "Safari";

  // OS detection
  let os = "Unknown";
  if (/Windows/i.test(ua)) os = "Windows";
  else if (/Macintosh|Mac OS/i.test(ua)) os = "macOS";
  else if (/iPhone|iPad|iPod/i.test(ua)) os = "iOS";
  else if (/Android/i.test(ua)) os = "Android";
  else if (/Linux/i.test(ua)) os = "Linux";

  return `${browser} on ${os}`;
}

/**
 * Simple hash of a string using djb2 algorithm. Returns a hex string.
 * No crypto dependency — deterministic and fast.
 */
function hashString(str: string): string {
  let hash = 5381;
  for (let i = 0; i < str.length; i++) {
    hash = ((hash << 5) + hash + str.charCodeAt(i)) >>> 0;
  }
  return hash.toString(16).padStart(8, "0");
}

function getDeviceFingerprint(): string {
  const parts = [
    navigator.userAgent,
    `${screen.width}x${screen.height}`,
    Intl.DateTimeFormat().resolvedOptions().timeZone,
    navigator.language,
  ];
  return hashString(parts.join("|"));
}

export function detectDevice(): DeviceInfo {
  return {
    device_type: getDeviceType(),
    client_type: "web_browser",
    device_name: getDeviceName(),
    device_fingerprint: getDeviceFingerprint(),
  };
}
